import {useSelector} from "react-redux";
import {setHeaderLoadType} from "../../slices/vehicleSlice";
import {useEffect} from "react";
import {dataLayerContainer, metadataContainer} from "./JDPAHeadImport"

const CustomHeadImport = () => {
    const headerLoadType = useSelector(setHeaderLoadType);

    useEffect(() => {
        if (headerLoadType != null) {

            metadataContainer();
            dataLayerContainer();

        }
    }, [headerLoadType]);
};
export default CustomHeadImport;